"use client"

import type { ErrorInfo } from "next/error"

export default function GlobalError({ error, retry }: ErrorInfo) {
    const message = error instanceof Error ? error.message : String(error)

    return (
        <html lang="en">
            <body className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
                <main className="max-w-lg text-center">
                    <h1 className="mb-3 font-semibold text-3xl tracking-tight">
                        A critical error occurred
                    </h1>
                    <p className="mb-2 text-muted-foreground text-sm">
                        The app ran into an unrecoverable issue.
                    </p>
                    <p className="mb-8 text-muted-foreground/80 text-xs">
                        {message}
                    </p>
                    <button
                        type="button"
                        onClick={() => {
                            retry()
                        }}
                        className="inline-flex items-center justify-center rounded-md bg-foreground px-4 py-2 font-medium text-background text-sm transition-opacity hover:opacity-90"
                    >
                        Reload application
                    </button>
                </main>
            </body>
        </html>
    )
}
